@if(visible()){
<div> <!-- class="jk-checkbox-border" -->
  <mat-checkbox [class]="jkClass()" [(ngModel)]="_value" [disabled]="disabled()" text="text"
    (change)="onCheckboxChange($event)">
    {{label()}}
  </mat-checkbox>
</div>
}
